module.exports = __webpack_public_path__ + "img/scene_pastel_colors_backlight@2x.fa290976.png";